import {
  ADD_PRODUCT_QUANTITY,
  ADD_PRODUCT_TO_CART,
  DECREASE_PRODUCT_QUANTITY,
  DECREASE_TIMER,
  FLASH_CART,
  INITIALIZE_TIMER,
  JUMP_PAGE,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  REMOVE_PRODUCT_FROM_CART,
  SET_CATEGORIES,
  SET_ERROR,
  SET_PRODUCTS,
  SET_THEME,
  SET_SHOPPING_CART_LIMIT,
  SET_TRANSACTION_AMOUNT_LIMIT,
  SET_TOUCHLESS_NEXT_PAGE,
  SET_TOUCHLESS_PAGE_COUNT,
  SET_TOUCHLESS_PAGE_LIMIT,
  SET_TOUCHLESS_PEVIOUS_PAGE,
  START_SESSION,
  START_TOUCHLESS_LOADING,
  STOP_SESSION,
  STOP_TOUCHLESS_LOADING,
  SET_TOUCHLESS_LOGO,
  SET_CURRENCY,
  CLEAR_CART,
} from "../constants/action-types";
import {
  loadCart,
  saveCart,
  clearCart,
} from "components/TouchlessVendingMachine/utils";
import _ from "lodash";

const initialState = {
  sessionData: null,
  cart_items: loadCart(),
  products: [],
  theme: {},
  shopLimit: 56,
  transactionLimit: null,
  currentPage: 1,
  categories: [],
  error: null,
  isLoading: false,
  timer: 0,
  timerIntervalId: null,
  limit: 9,
  count: 0,
  nextPage: null,
  prevPage: null,
  logo: null,
};

const touchLessReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case START_SESSION:
      return { ...state, sessionData: payload };
    case STOP_SESSION:
      clearCart();
      return { ...initialState };
    case CLEAR_CART:
      clearCart();
      return { ...state, cart_items: [] };
    case SET_TOUCHLESS_LOGO:
      return { ...state, logo: payload };
    case NEXT_PAGE:
      return { ...state, currentPage: state.currentPage + 1 };
    case PREVIOUS_PAGE:
      return { ...state, currentPage: state.currentPage - 1 };
    case JUMP_PAGE:
      return { ...state, currentPage: payload };
    case SET_TOUCHLESS_NEXT_PAGE:
      return { ...state, nextPage: payload };
    case SET_TOUCHLESS_PEVIOUS_PAGE:
      return { ...state, prevPage: payload };
    case SET_TOUCHLESS_PAGE_COUNT:
      return { ...state, count: payload };
    case SET_TOUCHLESS_PAGE_LIMIT:
      return { ...state, limt: payload };
    case INITIALIZE_TIMER:
      return {
        ...state,
        timer: payload.seconds,
        timerIntervalId: payload.timerIntervalId,
      };
    case DECREASE_TIMER:
      return { ...state, timer: state.timer - 1 };
    case SET_PRODUCTS:
      return { ...state, products: payload };
    case SET_CURRENCY:
      return { ...state, currency: payload };
    case SET_ERROR:
      return { ...state, error: payload };
    case SET_CATEGORIES:
      return { ...state, categories: payload };
    case START_TOUCHLESS_LOADING:
      return { ...state, isLoading: true };
    case STOP_TOUCHLESS_LOADING:
      return { ...state, isLoading: false };
    case ADD_PRODUCT_TO_CART: {
      const nextCart = [...state.cart_items, { ...payload, quantity: 1 }];
      saveCart(nextCart);
      return {
        ...state,
        cart_items: nextCart,
      };
    }
    case ADD_PRODUCT_QUANTITY: {
      const nextCart = _.map(state.cart_items, (x) =>
        x.id === payload
          ? { ...x, quantity: x.quantity ? x.quantity + 1 : 1 }
          : x
      );
      saveCart(nextCart);
      return {
        ...state,
        cart_items: nextCart,
      };
    }

    case DECREASE_PRODUCT_QUANTITY: {
      const nextCart = _.map(state.cart_items, (x) =>
        x.id === payload.product_id
          ? { ...x, quantity: payload.qty ? payload.qty : x.quantity - 1 }
          : x
      );
      const cleaned = nextCart.filter((x) => x.quantity > 0);
      saveCart(cleaned);
      return {
        ...state,
        cart_items: cleaned,
      };
    }

    case REMOVE_PRODUCT_FROM_CART: {
      const nextCart = _.filter(state.cart_items, (x) => x.id !== payload);
      saveCart(nextCart);
      return {
        ...state,
        cart_items: nextCart,
      };
    }
    case FLASH_CART: {
      saveCart([]);
      return {
        ...initialState,
        timer: state.timer,
        timerIntervalId: state.timerIntervalId,
      };
    }
    case SET_THEME:
      return { ...state, theme: payload };
    case SET_SHOPPING_CART_LIMIT:
      return { ...state, shopLimit: payload };
    case SET_TRANSACTION_AMOUNT_LIMIT:
      return { ...state, transactionLimit: payload || null };

    default:
      return state;
  }
};

export default touchLessReducer;
